export async function renameOrganization(
  name: string,
  id: string,
): Promise<Response> {
  return await fetch(`/v1/organizations/${id}/metadata`, {
    method: "PATCH",
    body: JSON.stringify({ name }),
  });
}
